/**
 * defa.views.UserNewAccountView
 * Informs the user that a new account has been created.
 * @version 1.2.0
 */
import View     from 'scripts/poppet/view';
import template from 'templates/userNewAccountView.jst.html';

const selectors = {
	buttonAccept: '[data-click=new-account-accept]',
};

const UserNewAccountView = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	ui: {
		accept: selectors.buttonAccept,
	},
	
	triggers: {
		'click @ui.accept': 'account:accept',
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default UserNewAccountView;